module.exports = "https://bicocca-network.servercdn.it/static/img/pin.png?3f341806d4f4b556f7cde7cd418937c0";